<template>
  <div class="panel-group">
    <div class="panel-wrapper">
      <div class="panel-wrapper-header">
        <div class="panel-wrapper-header-tabs">
          <widgetTabs v-model="activeTab" :tabs="[
            {
              title: 'Inbox',
              value: 'inbox',
              icon: {
                inactive: require('@/assets/icons/inbox-gray.svg'),
                active: require('@/assets/icons/inbox-green.svg')
              }
            },
            {
              title: 'Sent',
              value: 'sentEmails',
              icon: {
                inactive: require('@/assets/icons/sent-email-gray.svg'),
                active: require('@/assets/icons/sent-email-green.svg')
              }
            }
          ]" @change="switchTab"></widgetTabs>

        </div>
      </div>
      <div class="panel-wrapper-body" @scroll="handleScroll">
        <div class="content-loading-container" v-if="loading_page_data && !inboxEmails.length">
          <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="loading_page_data"
            :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
        </div>

        <div class="not-found" v-if="inboxEmails.length === 0 && !loading_page_data">
          <widgetNotFoundWidget title="No Emails Found" content="Your inbox is empty" align="center">
            <img class="widget-img" src="@/assets/icons/select-item.svg" />
          </widgetNotFoundWidget>
        </div>

        <div class="panel-wrapper-body-container" v-if="inboxEmails.length > 0">
          <div class="inbox-email-item" v-for="(item, index) in inboxEmails" :key="index" @click="selectItem(item)"
            :class="{
              active:
                selected_item_details && item.id === selected_item_details.id,
            }">
            <div class="inbox-email-item-header">
              <div class="inbox-email-item-header-profile" v-if="item.name">
                <widgetProfile :title="item.name" :subtitle="''" :file_name="null" :path="$fullUrl('images/profiles/')"
                  :size="25" :text_size="11"></widgetProfile>
              </div>
              <div class="inbox-email-item-header-title">{{ item.subject }}</div>
            </div>
            <div class="inbox-email-item-body">
              <div class="inbox-email-item-body-text">
                {{ htmlToText(item.message) }}
              </div>
            </div>
          </div>

          <!-- Bottom loader -->
          <div class="bottom-loader" v-if="loading_page_data">
            <loading :height="20" color="#1ba5a4" :opacity="1" :width="20" :active.sync="loading_page_data"
              :is-full-page="false" :can-cancel="false" background-color="#fff" class="loader"></loading>
          </div>
        </div>
      </div>
    </div>
    <div class="email-inbox-preview">
      <!-- Tab content details for email -->
      <div class="tab-content-details" v-if="selected_item_details">
        <div class="tab-content-details-header">
          <div class="tab-content-details-header-left-panel">
            <div class="email-user-profile">
              <widgetProfile :title="selected_item_details.name" :subtitle="''" :file_name="null"
                :path="$fullUrl('images/profiles/')" :size="40" :text_size="14"></widgetProfile>
            </div>
          </div>
          <div class="tab-content-details-options row">
            <dropdown-menu>
              <ul>
                <li>
                  <app-dialog title="Delete Email" ask="Are you sure you want to delete this email?" yesText="Delete"
                    noText="Cancel" @onComfirm="deleteEmail(selected_item_details)">
                    <a>Delete Email</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>
        <div class="tab-content-details-body" v-html="selected_item_details.message"></div>
      </div>

      <!-- When no item selected -->
      <div class="widget-notfound" v-if="!selected_item_details">
        <widgetNotFoundWidget title="No email selected" content="Select an email to view its details" align="center">
          <img class="widget-img" src="@/assets/icons/select-item.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      selected_item_details: null,
      inboxEmails: [],
      loading_page_data: false,
      activeTab: 1,
      pageToken: null
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("inboxEmailRefresh", () => {
      vm.getInboxEmails(true);
    });
    vm.getInboxEmails(true);
  },
  computed: {},
  watch: {},
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.$emit("switchTab", tab.value);
    },
    selectItem(item) {
      let vm = this;
      vm.selected_item_details = item;
    },
    deleteEmail(item) {
      let vm = this;
      vm.$store
        .dispatch("EMAIL_DELETE_INBOX", { id: item.id })
        .then((responce) => {
          vm.selected_item_details = null;
          vm.getInboxEmails();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Email is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something wrong while deleting email",
            type: "warn",
            duration: 3000,
          });
        });
    },
    getInboxEmails(initialData = false) {
      let vm = this;
      vm.loading_page_data = true;
      vm.$store
        .dispatch("EMAIL_GET_ALL_INBOX", { pageToken: vm.pageToken, initialData: initialData })
        .then((responce) => {
          vm.loading_page_data = false;
          vm.pageToken = responce.data.pageToken;
          if (initialData) {
            vm.inboxEmails = vm.formattedEmail(responce.data.data);
          } else {
            // push new item to inboxEmails
            let newItems = vm.formattedEmail(responce.data.data);
            vm.inboxEmails.push(...newItems);
          }
        })
        .catch((error) => {
          vm.loading_page_data = false;
        });
    },
    formattedEmail(data) {
      return data.map((item) => {
        const headers = item.payload.headers;
        const attachments = [];
        let message = '';
        let name = '';

        // Extract name from From header
        const fromHeader = headers.find(h => h.name === "From")?.value || "";
        // Parse name from format: "Name <email@domain.com>" or just "email@domain.com"
        const nameMatch = fromHeader.match(/^"?([^"<]+)"?\s*<?.*>?$/);
        name = nameMatch ? nameMatch[1].trim() : fromHeader;

        // Process message content and attachments from payload parts
        if (item.payload.parts) {
          item.payload.parts.forEach(part => {
            // Extract message from text/plain part
            if (part.mimeType === 'text/plain' && part.body.data) {
              const decodedBody = atob(part.body.data.replace(/-/g, '+').replace(/_/g, '/'));
              message = decodedBody;
            }

            // Handle attachments
            if (part.filename && part.mimeType && !part.mimeType.startsWith('text/')) {
              attachments.push({
                filename: part.filename,
                mimeType: part.mimeType,
                attachmentId: part.body.attachmentId,
                size: part.body.size
              });
            }

            // Check nested parts
            if (part.parts) {
              part.parts.forEach(nestedPart => {
                // Extract message from nested text/plain part if main message is empty
                if (!message && nestedPart.mimeType === 'text/plain' && nestedPart.body.data) {
                  const decodedBody = atob(nestedPart.body.data.replace(/-/g, '+').replace(/_/g, '/'));
                  message = decodedBody;
                }

                if (nestedPart.filename && nestedPart.mimeType && !nestedPart.mimeType.startsWith('text/')) {
                  attachments.push({
                    filename: nestedPart.filename,
                    mimeType: nestedPart.mimeType,
                    attachmentId: nestedPart.body.attachmentId,
                    size: nestedPart.body.size
                  });
                }
              });
            }
          });
        } else if (item.payload.body.data) {
          // Handle case where message is in the main body
          const decodedBody = atob(item.payload.body.data.replace(/-/g, '+').replace(/_/g, '/'));
          message = decodedBody;
        }

        const formattedEmail = {
          id: item.id,
          threadId: item.threadId,
          historyId: item.historyId,
          internalDate: item.internalDate,
          snippet: item.snippet,
          sizeEstimate: item.sizeEstimate,
          // Extract relevant header information
          from: headers.find(h => h.name === "From")?.value || "",
          to: headers.find(h => h.name === "To")?.value || "",
          subject: headers.find(h => h.name === "Subject")?.value || "",
          date: headers.find(h => h.name === "Date")?.value || "",
          // Add name and message
          name: name,
          message: message || item.snippet, // Fallback to snippet if no message body found
          // Add attachments array
          attachments: attachments,
          // Add required UI state properties
          editing: false,
          loading: false
        };

        return formattedEmail;
      });
    },
    handleScroll(e) {
      let vm = this;
      if (vm.pageToken) {
        const element = e.target;
        if (!vm.loading_page_data && element.scrollHeight - element.scrollTop === element.clientHeight) {
          vm.getInboxEmails();
        }
      }
    }

  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.panel-group {
  width: 100%;
  display: flex;
  height: 100%;

  .panel-wrapper {
    width: 320px;
    height: 100%;

    .panel-wrapper-header {
      height: 50px;
      background: #ffffff;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;

      .panel-wrapper-header-tabs {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        width: 100%;

        .tabs-widget {
          display: flex;
          width: 100%;

          .tabs-item {
            display: flex;
            align-items: center;
            margin-right: 20px;
            cursor: pointer;

            .tabs-item-icon {
              margin-right: 5px;
              display: flex;
              align-items: center;
              height: 100%;

              img {
                width: 14px;
              }

              .active-icon {
                display: none;
              }
            }

            .tabs-item-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 14px;
              color: #707070;
            }

            &.active,
            &:hover {
              .tabs-item-title {
                color: #1ba5a4;
              }

              .tabs-item-icon {
                .inactive-icon {
                  display: none;
                }

                .active-icon {
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    .panel-wrapper-body {
      height: calc(100% - 50px);
      overflow-y: auto;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;

      .panel-wrapper-body-container {
        background: #ffffff;
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
        padding-bottom: 10px;

        .inbox-email-item {
          padding: 6px 6px;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            background: #f4f4f4;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
            transition: 0.1s ease-in-out;
          }

          &.active {
            background: #f4f4f4;
            transition: 0.1s ease-in-out;
          }

          .inbox-email-item-header {
            display: flex;
            flex-direction: column;
            margin-bottom: 7px;

            .inbox-email-item-header-profile {
              margin-right: 5px;
              margin-bottom: 10px;
            }

            .inbox-email-item-header-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 19px;
              color: #1c1c1c;
            }
          }

          .inbox-email-item-body {
            .inbox-email-item-body-text {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 400;
              font-size: 11px;
              color: #8e8b8b;
              overflow: hidden;
              display: block;
              max-height: 4rem;
              -webkit-line-clamp: 2;
              display: box;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              white-space: normal;
            }
          }
        }

        .bottom-loader {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 10px 0;
          background: #ffffff;
          position: relative;
        }
      }

      .content-loading-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: #ffffff;
      }

      .not-found {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        background: #ffffff;
      }
    }
  }

  .email-inbox-preview {
    width: calc(100% - 320px);
    height: 100%;
    border-radius: 7px;
    margin-left: 5px;

    .tab-content-details {
      width: 100%;
      height: max-content;
      border-radius: 5px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      padding: 0px 15px;
      padding-bottom: 80px;

      .tab-content-details-header {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tab-content-details-header-left-panel {
          .email-user-profile {
            margin-bottom: 10px;
          }
        }

        .tab-content-details-options {
          display: flex;
          align-items: center;
        }
      }

      .tab-content-details-body {
        padding: 15px;
        background: #fafafa;
        border-radius: 10px;

        p {
          margin: 0px;
          margin-bottom: 3px;
        }
      }
    }

    .widget-notfound {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #ffffff;
    }
  }
}
</style>